var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoffeeMapIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#BA0229"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.60073 12.2857H11.2004C12.1941 12.2857 13.0003 11.5179 13.0003 10.5714H13.6002C14.9238 10.5714 16 9.54643 16 8.28571C16 7.025 14.9238 6 13.6002 6H6.25085C6.0015 6 5.80089 6.19107 5.80089 6.42857V10.5714C5.80089 11.5179 6.60707 12.2857 7.60073 12.2857ZM13.6002 7.14286C14.262 7.14286 14.8001 7.65536 14.8001 8.28571C14.8001 8.91607 14.262 9.42857 13.6002 9.42857H13.0003V7.14286H13.6002ZM14.4945 14H4.90659C4.01417 14 3.76294 12.8571 4.23165 12.8571H15.1676C15.6363 12.8571 15.3888 14 14.4945 14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffeeMapIcon);
export default __webpack_public_path__ + "static/media/coffee-map-icon.86d79634d7034574752c5619ea896902.svg";
export { ForwardRef as ReactComponent };